import { Injectable } from '@angular/core';

/**
 * The tab's own URL: where it is, and sending it somewhere else.
 *
 * Both halves of the web build's federated Grant go through here — the authorization request replaces
 * the page, and the response is read off the page it comes back to. One service rather than two
 * tokens, because they are the same concern seen from each end.
 *
 * Injectable for the same reason `AUTH_CLOCK` is: what a launch *is* depends on this.
 * `window.location` is non-configurable in jsdom, so a spec cannot replace it — without this seam
 * the launch decision would only be testable in a browser.
 *
 * Native never uses it. The Grant is not interrupted by a page load there, and the callback arrives
 * as a deep link.
 */
@Injectable({ providedIn: 'root' })
export class BrowserLocation {
  /** Where this page was loaded, which is how a returning redirect is recognised. */
  href(): string {
    return window.location.href;
  }

  /**
   * Send the tab somewhere else. Nothing after this runs — the JS context is being replaced.
   *
   * `assign` rather than `replace`: the sign-in page stays in history, which is what makes the
   * browser's Back button a way out of a provider screen someone changed their mind about.
   */
  assign(url: string): void {
    window.location.assign(url);
  }
}
